import _ from 'lodash';

/* @ngInject */
export default function TankPanelService($q, $sails, $log, EquipmentInfoService) {
  const service = this;

  const hunid = 100;

  service.tankModel = {};

  service.createModel = createModel;
  service.getEquipmentFromIds = getEquipmentFromIds;
  service.updateTankValuesFromEvent = updateTankValuesFromEvent;
  service.getSummaryData = getSummaryData;
  service.newReportData = newReportData;
  service.updateReportDataObj = updateReportDataObj;
  service.destroy = destroy;

  function createModel(panelId) {
    service.tankModel[panelId] = {
      Summary: {
        equipment: {
          name: 'Summary',
          id: 'Summary'
        }
      }
    };
    return service.tankModel[panelId];
  }

  function getEquipmentFromIds(panelId, equipmentIds) {
    return EquipmentInfoService.getFullEquipment(equipmentIds)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          service.tankModel[panelId][eq.id] = {
            equipment: eq,
            data: {
              event: {},
              reports: []
            }
          };
        });
        return equipment;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getSummaryData(panelId, equipmentId) {
    return $sails.get(`/event/getTankSummary/${equipmentId}`)
      .then((res) => {
        const data = service.tankModel[panelId][equipmentId].data;
        if (_.isObject(res.data.event) && _.isArray(res.data.reports)) {
          data.event = tankEventToData(res.data.event);
          data.reports = reportArrayToData(res.data.reports);
          recalculateSummary(panelId);
        } else {
          $log.error('Unexpected event data structure.');
        }
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function tankEventToData(event) {
    const da = event.data;
    const returnObj = {};

    if (_.isNumber(da.temperature)) {
      returnObj.temperature = da.temperature;
    }
    if (_.isNumber(da.voltage)) {
      returnObj.voltage = da.voltage;
    }
    if (_.every([da.topLevel, da.correctionFactor, da.inchesToBarrels, da.waterLevel, da.sizeInInches], _.isNumber)) {
      _.merge(returnObj, {
        topInches: da.topLevel + da.correctionFactor,
        oilInches: da.topLevel - da.waterLevel,
        topBarrels: (da.topLevel + da.correctionFactor) * da.inchesToBarrels,
        oilBarrels: (da.topLevel - da.waterLevel) * da.inchesToBarrels,
        waterInches: da.waterLevel + da.correctionFactor,
        waterBarrels: (da.waterLevel + da.correctionFactor) * da.inchesToBarrels,
        percentOil: (da.topLevel - da.waterLevel) / da.sizeInInches * hunid,
        percentWater: (da.waterLevel + da.correctionFactor) / da.sizeInInches * hunid,
        sizeInInches: da.sizeInInches,
        tankSizeBbls: da.sizeInInches * da.inchesToBarrels
      });
    }
    if (event.eventDate) {
      returnObj.lastUpdated = event.eventDate;
    }

    return returnObj;

  }

  function updateTankValuesFromEvent(panelId, eventObj) {
    _.merge(service.tankModel[panelId][eventObj.equipment.id].data.event, tankEventToData(eventObj));
    recalculateSummary(panelId);
  }

  function reportArrayToData(reportArray) {
    if (reportArray.length === 0) {
      return [{
        total: 0,
        oil: 0,
        water: 0,
        id: 'none'
      }, {
        total: 0,
        oil: 0,
        water: 0,
        id: 'none'
      }];
    } else if (reportArray.length === 1) {
      const { topProduction, oilProduction, waterProduction, id } = reportArray[0];
      return [{
        topProduction,
        oilProduction,
        waterProduction,
        id
      }, {
        topProduction: 0,
        oilProduction: 0,
        waterProduction: 0,
        id: 'none'
      }];
    }
    const rP0 = reportArray[0];
    const rP1 = reportArray[1];
    return [{
      topProduction: rP0.topProduction,
      oilProduction: rP0.oilProduction,
      waterProduction: rP0.waterProduction,
      id: rP0.id
    }, {
      topProduction: rP1.topProduction,
      oilProduction: rP1.oilProduction,
      waterProduction: rP1.waterProduction,
      id: rP1.id
    }];
  }


  function newReportData(panelId, reportArray) {
    service.tankModel[panelId][reportArray[0].equipment].data.reports = reportArrayToData(reportArray);
    recalculateSummary(panelId);
  }

  function updateReportDataObj(panelId, reportObj) {
    if (_.has(service.tankModel[panelId], reportObj.equipment)) {
      _.forEach(service.tankModel[panelId][reportObj.equipment].data.reports, (report) => {
        if (report.id === reportObj.id) {
          report.topProduction = reportObj.topProduction;
          report.oilProduction = reportObj.oilProduction;
          report.waterProduction = reportObj.waterProduction;
        }
      });
      recalculateSummary(panelId);
    }
  }

  function recalculateSummary(panelId) {
    service.tankModel[panelId].Summary.data = {
      event: {
        temperature: 0,
        voltage: 0,
        topInches: 0,
        topBarrels: 0,
        oilInches: 0,
        oilBarrels: 0,
        waterInches: 0,
        waterBarrels: 0,
        sizeInInches: 0,
        tankSizeBbls: 0
      },
      reports: [{
        topProduction: 0,
        oilProduction: 0,
        waterProduction: 0
      }, {
        topProduction: 0,
        oilProduction: 0,
        waterProduction: 0
      }]
    };
    const sumDat = service.tankModel[panelId].Summary.data;
    _.forEach(service.tankModel[panelId], ({ data: tDat, equipment: tEquip }) => {
      if (tEquip.id !== 'Summary') {
        _.forEach(tDat.event, (val, key) => {
          if (key !== 'lastUpdated') {
            sumDat.event[key] += val;
          }
        });
        let pos = 0;
        _.forEach(tDat.reports, (report) => {
          _.forEach(report, (val, key) => {
            sumDat.reports[pos][key] += val;
          });
          pos++;
        });
        if (_.has(tDat, ['event', 'lastUpdated'])) {
          if (_.has(sumDat, ['event', 'lastUpdated'])) {
            // show updated date as most recent eventDate
            sumDat.event.lastUpdated =
                sumDat.event.lastUpdated < tDat.event.lastUpdated ? tDat.event.lastUpdated : sumDat.event.lastUpdated;
          } else {
            sumDat.event.lastUpdated = tDat.event.lastUpdated;
          }
        }
      }
    });
    sumDat.event.percentOil = (sumDat.event.oilInches / sumDat.event.sizeInInches) * hunid;
    sumDat.event.percentWater = (sumDat.event.waterInches / sumDat.event.sizeInInches) * hunid;
  }

  function destroy(panelId) {
    delete service.tankModel[panelId];
  }
}
